module.exports = __webpack_public_path__ + "resources/img/img_magic_eam_en.86955e690040882a220e2e9136f0f43b.png";